import { render, staticRenderFns } from "./SourcingTableExpansion.vue?vue&type=template&id=2ec995c7&scoped=true"
import script from "./SourcingTableExpansion.vue?vue&type=script&lang=js"
export * from "./SourcingTableExpansion.vue?vue&type=script&lang=js"
import style0 from "./SourcingTableExpansion.vue?vue&type=style&index=0&id=2ec995c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec995c7",
  null
  
)

export default component.exports